module.exports = __webpack_public_path__ + "img/17.9206b871.png";